import { SpotPolicy } from '../state/types';

export const SPOT_POLICY_MAPPER = {
  [SpotPolicy.FORCE_APPROVE_ALL]: 'force_approve_all',
  [SpotPolicy.APPROVE_ALL]: 'approve_all',
  [SpotPolicy.PUBLISH_AND_MODERATE]: 'publish_and_moderate',
  [SpotPolicy.REQUIRE_APPROVAL]: 'require_approval',
  [SpotPolicy.BLOCK_ALL]: 'block_all',
  [SpotPolicy.FORCE_BLOCK_ALL]: 'force_block_all'
};

export function getSpotPolicyFromString(strPolicy: string): SpotPolicy {
  switch (strPolicy) {
    case 'force_approve_all':
      return SpotPolicy.FORCE_APPROVE_ALL;
    case 'approve_all':
      return SpotPolicy.APPROVE_ALL;
    case 'publish_and_moderated':
      return SpotPolicy.PUBLISH_AND_MODERATE;
    case 'require_approval':
      return SpotPolicy.REQUIRE_APPROVAL;
    case 'block_all':
      return SpotPolicy.BLOCK_ALL;
    case 'force_block_all':
      return SpotPolicy.FORCE_BLOCK_ALL;
    default:
      return SpotPolicy.APPROVE_ALL;
  }
}

export function isStrongerPolicy(policyA: SpotPolicy, policyB: SpotPolicy) {
  return policyA < policyB;
}
